const momentsGalleryImageList = [
  "v1783928437/DJI_20260707115907_0008_D_xag4ot.webp",
  "v1785311438/DSC00522_vyppts.webp",
  "v1785311757/IMG_8564_jkfm7r.webp",
  "v1785121480/DJI_20260715152255_0050_D_qy3eue.webp",
  "v1741535462/20250307215516_b70rgq.webp",
  "v1784189987/image4_gbt8eh.webp",
  "v1784266422/DSC00400-2_ddg5if.jpg",
  "v1784766584/DJI_20260721090315_0012_D_nm08ha.webp",
  "v1783930567/DSC00215_gpomzw.webp",
  "v1784191325/image9_vwojco.webp",
  "v1784944008/DJI_20260724142728_0046_D_fjvofb.webp",
  "v1784766585/DJI_20260722154007_0060_D_azbuxt.webp",
  "v1784767309/IMG_5481_ie849d.jpg",
  "v1784734130/DJI_20260722152642_0033_D_tb9qki.webp",
  "v1784682749/DJI_20260721090156_0009_D_al9eb0.webp",
  "v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg",
  "v1785005395/DSC00157_small_rnomp6.jpg",
  "v1785005394/DSC00161_small_f5qnkn.jpg",
  "v1785005393/DSC00178_small_hexny7.jpg",
  "v1784767636/IMG_5428_oepvhn.jpg",
  "v1785005393/DSC00191_small_lhfvnk.jpg",
  "v1784766584/DJI_20260715152007_0040_D_rrrztf.webp",
  "v1784945639/DSC00440-2_syxyio.webp",
  "v1784268196/image10_xcny11.webp",
  "v1784766584/DJI_20260705181738_0011_D_zdyxkf.webp",
  "v1785004077/DJI_20260707125430_0025_D_small_r4mnrd.jpg",
  "v1784266410/DJI_20260714133703_0069_D_cp1tbk.webp",
  "v1784766584/DJI_20260715125937_0011_D_ovrkkz.webp",
  "v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg",
];

export const momentsGalleryImages = Array.from(
  new Set(momentsGalleryImageList),
);

export const momentsGalleryMedia = momentsGalleryImages;
